import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    listItem: {
      borderRadius: 5,
      padding: '0.2rem 1.2rem',

      '&::after': {
        content: '""',
        background: '#CECFCE',
        minWidth: 10,
        width: 10,
        minHeight: 10,
        height: 10,
        borderRadius: '50%',
      },

      '& + .MuiListItem-root': {
        marginTop: '0.5rem',
      },

      '& .MuiTypography-body2': {
        fontWeight: 600,
        fontSize: '1.4rem',
        color: '#7A7A7A',
        marginRight: '0.5rem',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },

      '& .MuiListItemIcon-root': {
        minWidth: 'initial',
        marginRight: '1rem',

        '& .material-symbols-outlined': {
          fontSize: 22,
          marginLeft: -2,
        },
      },

      '&.Mui-selected': {
        background: '#CCCEE5',

        '& .MuiTypography-body2': {
          color: theme.palette.secondary.main,
          fontWeight: 600,
          fontSize: '1.4rem',
        },
        '& .MuiSvgIcon-root': {
          color: theme.palette.secondary.main,
        },

        '&::after': {
          background: '#55AFCB',
        },
      },
    },
    dotGreen: {
      '&::after': {
        background: '#23AA50',
      },
    },
  }),
)
